import { render, staticRenderFns } from "./UnsubscribeView.vue?vue&type=template&id=08d0b8bb&lang=pug"
import script from "./UnsubscribeView.vue?vue&type=script&lang=ts"
export * from "./UnsubscribeView.vue?vue&type=script&lang=ts"
import style0 from "./UnsubscribeView.vue?vue&type=style&index=0&id=08d0b8bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
